/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpAdminActionResponse
 */
export interface FuelUpAdminActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpAdminActionResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof FuelUpAdminActionResponse
     */
    message: string;
    /**
     * 
     * @type {object}
     * @memberof FuelUpAdminActionResponse
     */
    result?: object;
}

/**
 * Check if a given object implements the FuelUpAdminActionResponse interface.
 */
export function instanceOfFuelUpAdminActionResponse(value: object): value is FuelUpAdminActionResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function FuelUpAdminActionResponseFromJSON(json: any): FuelUpAdminActionResponse {
    return FuelUpAdminActionResponseFromJSONTyped(json, false);
}

export function FuelUpAdminActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpAdminActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'result': json['result'] == null ? undefined : json['result'],
    };
}

export function FuelUpAdminActionResponseToJSON(json: any): FuelUpAdminActionResponse {
    return FuelUpAdminActionResponseToJSONTyped(json, false);
}

export function FuelUpAdminActionResponseToJSONTyped(value?: FuelUpAdminActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'result': value['result'],
    };
}

